import React from 'react'
import { Link, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import CompetitionSubmit from './pages/CompetitionSubmit'
import CompetitionEdit from './pages/CompetitionEdit'
import Judge from './pages/Judge'
import Admin from './pages/Admin'

export default function App() {
  return (
    <div className="container">
      <header className="row site-header">
        <Link to="/" className="brand-link">
          <img
            src="https://celbridgecameraclub.net/wp-content/uploads/2025/08/CameraClubLogo.png"
            alt="Celbridge Camera Club"
            className="brand-logo"
          />
        </Link>
        <div>
          <Link to="/" style={{fontWeight: 800, fontSize: 18}}>Celbridge Camera Club Competitions</Link>
          <div><small className="muted">Submit entries, manage competitions, and complete judging.</small></div>
        </div>
      </header>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/c/:slug" element={<CompetitionSubmit />} />
        <Route path="/c/:slug/edit/:token" element={<CompetitionEdit />} />
        <Route path="/j/:slug/:token" element={<Judge />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="*" element={<div className="card">Not found</div>} />
      </Routes>

      <footer style={{marginTop: 24, opacity: .7}}>
        <small>Need help? Contact your competition organizer.</small>
      </footer>
    </div>
  )
}
